import gql from 'graphql-tag';

const createAuctionAccessBlacklistMutation = gql`
  mutation createAuctionAccessBlacklist(
    $input: CreateAuctionAccessBlacklistInput!
  ) {
    createAuctionAccessBlacklist(input: $input) {
      success
      errors
    }
  }
`;

export default createAuctionAccessBlacklistMutation;
